var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5863 27.5133C49.7921 27.4359 49.9706 27.2998 50.0998 27.1219C50.229 26.944 50.3032 26.7322 50.3131 26.5125C50.323 26.2929 50.2682 26.0752 50.1555 25.8864C50.0429 25.6976 49.8773 25.546 49.6793 25.4505L49.4723 25.3505L17.9892 10.143L17.9861 10.1429L17.0027 9.66609C16.8164 9.57587 16.6087 9.53891 16.4027 9.5593C16.1966 9.57969 16.0002 9.65663 15.8352 9.78163C15.6701 9.90662 15.5428 10.0748 15.4674 10.2676C15.3919 10.4604 15.3712 10.6703 15.4075 10.8741L15.5976 11.948L15.5958 11.9527L17.6959 23.9182L17.8944 25.0512L17.5947 26.1618L14.4267 37.8899L14.4264 37.8962L14.1405 38.9486C14.0867 39.1481 14.089 39.3586 14.1471 39.557C14.2053 39.7553 14.317 39.9337 14.47 40.0726C14.6231 40.2115 14.8114 40.3055 15.0144 40.3442C15.2174 40.3829 15.4272 40.3649 15.6206 40.2921L16.6461 39.9058L49.3728 27.5927L49.5879 27.5117L49.5863 27.5133ZM43.6747 27.3374L46.3418 26.3335L43.7758 25.0937L19.9935 24.0217L20.1491 24.908C20.1778 25.0705 20.1702 25.2374 20.1271 25.3967L19.8923 26.2654L43.6747 27.3374Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b6a3c9fd5805926fd3067a60e136e28e.svg";
export { ForwardRef as ReactComponent };